export default __webpack_public_path__ + "static/media/appScreen.06958ab7.png";